import { ConditionalRuleEditorProps } from "@graffer-inc/form-builder";
import { FormSchemaConverter } from "@graffer-inc/form-schema";
import { ThenRulesEditor } from "./then-rules-editor";
import { IfConditionsViewer } from "../if-conditions-viewer";
import { ApplicantSchemaKeys } from "@graffer-inc/cloud-gov-core";

export const ApplicantConditionalRuleEditor: React.FC<
  ConditionalRuleEditorProps & {
    applicantSchemaKeys: ApplicantSchemaKeys;
    isSafeEditOnly: boolean;
  }
> = ({
  formSchema,
  rule,
  // ruleIndex,
  onUpdate,
  thenDisplayFilter,
  applicantSchemaKeys,
  isSafeEditOnly,
}) => {
  const converter = new FormSchemaConverter(formSchema);
  const ifCandidates = converter.ifCandidates();
  const flatten = converter.flatten();

  return (
    <div className="px-3">
      <div
        style={{
          marginBottom: "24px",
        }}
      >
        <div className="level mb-4" style={{ marginBottom: 0 }}>
          <div className="level-left">
            <p className="title is-size-5">条件付き設定</p>
          </div>
          <div className="level-right" />
        </div>
        <p
          className="title is-size-5"
          style={{
            borderLeft: "3px solid #40bfb0",
            paddingLeft: "6px",
          }}
        >
          条件
        </p>
        <div
          style={{
            paddingLeft: "6px",
          }}
        >
          <IfConditionsViewer
            ifConditions={rule.if}
            ifCandidates={ifCandidates}
          />
        </div>
      </div>
      <div
        style={{
          marginBottom: "24px",
        }}
      >
        <p
          className="title is-size-5"
          style={{
            borderLeft: "3px solid #40bfb0",
            paddingLeft: "12px",
          }}
        >
          適用される設定
        </p>
        <div
          style={{
            paddingLeft: "6px",
          }}
        >
          <ThenRulesEditor
            ifSet={rule.if}
            thenRules={rule.then.rules}
            thenCandidates={flatten}
            thenDisplayFilter={thenDisplayFilter}
            onUpdate={(then) => {
              onUpdate({
                ...rule,
                then: { rules: then },
              });
            }}
            applicantSchemaKeys={applicantSchemaKeys}
            isSafeEditOnly={isSafeEditOnly}
          />
        </div>
      </div>
    </div>
  );
};
